module.exports = __webpack_public_path__ + "d2ca-swap-bg.webp";